// src/components/Mascot.js
// Same character the extension draws in its "Michii says" bubble (content.js).
const Mascot = ({ size = 44, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 44 44" fill="none" aria-hidden="true">
    <circle cx="22" cy="22" r="21" fill="#1a0f00" stroke="#E8521C" strokeWidth="1.5" />
    <rect x="11" y="11" width="22" height="3.5" rx="1.75" fill="#E8521C" />
    <rect x="16" y="7" width="12" height="5" rx="2" fill="#E8521C" />
    <line x1="29" y1="11" x2="33" y2="16" stroke="#F0B94A" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="33" cy="17" r="1.5" fill="#F0B94A" />
    <ellipse cx="16.5" cy="22" rx="3.5" ry="3.5" fill="white" />
    <ellipse cx="27.5" cy="22" rx="3.5" ry="3.5" fill="white" />
    <circle cx="17" cy="22.5" r="1.8" fill="#1a1a1a" />
    <circle cx="28" cy="22.5" r="1.8" fill="#1a1a1a" />
    <circle cx="17.8" cy="21.6" r="0.7" fill="white" />
    <circle cx="28.8" cy="21.6" r="0.7" fill="white" />
    <path d="M15 29 Q22 34 29 29" stroke="#E8521C" strokeWidth="1.8" fill="none" strokeLinecap="round" />
    <line x1="8" y1="34" x2="14" y2="26" stroke="#E8521C" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="8" cy="35" r="2" fill="#F0B94A" />
  </svg>
);

export default Mascot;
